export const AvailablePaxListTableColumns = [
  { key: "reservationDate", label: "Reservation Date" },
  { key: "id", label: "Slot ID" },
  { key: "slotTitle", label: "Slot Title" },
  { key: "timeSlot", label: "Time Slot" },
  { key: "maxPax", label: "Max Pax" },
  { key: "availablePax", label: "Available Pax" },
  { key: "activePax", label: "Active Pax" },
  { key: "completedPax", label: "Completed Pax" },
  { key: "cancelledPax", label: "Cancelled Pax" },
  { key: "status", label: "Status" },
];
